import type { RouteRecordRaw } from 'vue-router';

// A3 distribute routes per ADR-007 §Per-endpoint role table:
//   distribute (assets) → admin
//   distribute-roster (read + walk-up) → admin|staff
export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/share',
    name: 'distribute',
    component: () => import('./pages/DistributePage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'admin',
      // Visible in every status (2026-08-07 lifecycle-stable nav): draft
      // renders a publish-first nudge, post-close renders as-is.
      lifecycle: ['draft', 'published', 'open', 'closed'],
    },
  },
  {
    path: '/auctions/:id/bidders',
    name: 'distribute-roster',
    // The roster folded into the Console (2026-08-10 console redesign);
    // this redirects old deep links to the phase's console surface,
    // preserving ?pay= chip deep links.
    component: () => import('./pages/RosterRedirect.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'any',
      // Every status: this route only redirects, so a stale deep link must
      // resolve from whatever phase the auction is in rather than tripping
      // the lifecycle guard and landing somewhere unrelated.
      lifecycle: ['draft', 'published', 'open', 'closed'],
    },
  },
];
